import React, { useEffect, useState } from 'react'
import { Calendar, Badge, Table } from 'antd';
import { getAttendanceByEmail } from '../../../firebase/utils';
import CommonModal from '../../UiKits/Modals/common/modal';

const CalenderModal = ({ data, setCalendarModel, calendarModel: { details, show } }) => {
  const initialStudentAttendance = {
    present: 0,
    absent: 0,
    leave: 0,
    totalClassesTillDate: 0,
    totalCourseClasses: 0
  };
  const [attendance, setAttendance] = useState([]);
  const [stdAtt, setStdAtt] = useState([]);
  const [studentAttendance, setStudentAttendance] = useState(initialStudentAttendance);
  const [loading, setLoading] = useState(true);
  const getAttend = async () => {
    try {
      const res = await getAttendanceByEmail(data?.email);
      setStdAtt(res)
    } catch (error) {
      console.log("error", error)
    }
  }
  const getStdAttDataColumn = [
    {
      title: "Present",
      dataIndex: "present",
    },
    {
      title: "Absent",
      dataIndex: "absent",
    },
    {
      title: "Leave",
      dataIndex: "leave",
    },
    {
      title: "Total Classes Till Date",
      dataIndex: "totalClassesTillDate",
    },
    {
      title: "Total Course Classes",
      dataIndex: "totalCourseClasses",
    }
  ]
  const updateAttendance = (data) => {
    const updatedAttendance = {};

    data.forEach((doc) => {
      const attendanceData = doc;
      const { attendanceDate, status } = attendanceData;
      updatedAttendance[attendanceDate] = status;
    });
    setAttendance(updatedAttendance);
    setLoading(false);
    checkTotalDays(updatedAttendance)
  };

  useEffect(() => {
    getAttend();
    getAttendanceByEmail(data?.email).then((data) => {
      updateAttendance(data);
    });
  }, [])

  const checkTotalDays = (attendance) => {
    setLoading(true)
    const startDate = new Date(details.startDate);
    const endDate = new Date(details.endDate);
    const days = details.days;
    const today = new Date();
    const classDays = days.toUpperCase().split(/[ &]+/);
    let current = new Date(startDate);
    let totalDaysFromStart = 0;
    let totalCourseClasses = 0;
    let currentDate = new Date(startDate);
    let currentDateCount = new Date(startDate);
    let present = 0;
    let absent = 0;
    let leave = 0;
    let totalClassesTillDate = 0;

    // Calculate total number of class days
    while (currentDate <= endDate) {
      if (classDays.includes(currentDate.toLocaleString("en-US", { weekday: "short" }).toUpperCase())) {
        totalCourseClasses++;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Calculate number of class days from start date until today
    current = new Date(startDate);
    while (current <= today) {
      if (classDays.includes(current.toLocaleString("en-US", { weekday: "short" }).toUpperCase())) {
        totalDaysFromStart++;
      }
      current.setDate(current.getDate() + 1);
    }

    // Calculate attendance for each day and total attendance till date
    currentDateCount = new Date(startDate);
    while (currentDateCount <= endDate) {
      const dateString = currentDateCount.toISOString().split('T')[0];
      const status = attendance[dateString];
      if (status === 'present') {
        present++;
      } else if (status === 'absent') {
        absent++;
      } else if (status === 'leave') {
        leave++;
      }
      currentDateCount.setDate(currentDateCount.getDate() + 1);
    }
    totalClassesTillDate = present + absent + leave;

    // Adjust absent count if necessary
    if (totalDaysFromStart > totalClassesTillDate) {
      absent = absent + (totalDaysFromStart - totalClassesTillDate);
    }
    setStudentAttendance({
      present: present,
      absent: absent,
      leave: leave,
      totalClassesTillDate: totalDaysFromStart,
      totalCourseClasses: totalCourseClasses
    })
    setLoading(false)
  }

  const closeUserDetail = () => {
    setCalendarModel({
      show: false,
      details: {}
    })
  }
  return (
    <CommonModal
      isOpen={show}
      toggler={closeUserDetail}
      showCloseBtn={true}
      successText={'Close'}
      title="Attendance Calender"
      success={closeUserDetail}
      bodyClass='full-screen-modal'
      size="lg"
    >
      <div>
        <div className='m-b-20 ant-design-table not-margin'>
          <Table
            loading={loading}
            rowClassName={(record) => record ? 'table-row-text' : ''}
            columns={getStdAttDataColumn}
            bordered={true}
            pagination={false}
            scroll={{ x: "auto" }}
            dataSource={[studentAttendance]} />
        </div>
        <Calendar dateCellRender={(date) => {
          const currentDate = new Date(date).toISOString().split('T')[0];
          const statusItem = stdAtt.find(item => item.attendanceDate === currentDate);
          if (statusItem) {
            return (
              <div>
                {statusItem.status === "absent" || statusItem.status === "leave" ?
                  (
                    <div>
                      <Badge status="error" text={statusItem.status} />
                      <h6>{statusItem.reason}</h6>
                    </div>
                  )
                  : (
                    <Badge status="processing" text={statusItem.status} />
                  )}
              </div>
            );
          }
          return null;
        }} />
      </div>
    </CommonModal>
  )
}

export default CalenderModal